module.exports = __webpack_public_path__ + "static/media/19.e5004de5.jpg";